import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '@/screens/home/Home.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/media',
    name: 'Media',
    component: () => import('@/screens/media/Media.vue'),
  },
  {
    path: '/media/:videoPublicationSlug',
    name: 'Video',
    component: () => import('@/screens/media/Video.vue'),
  },
  {
    path: '/teknologi',
    name: 'Technology',
    component: () => import('@/screens/tech/Tech.vue'),
  },
  {
    path: '/om-oss',
    name: 'AboutUs',
    component: () => import('@/screens/aboutUs/AboutUs.vue'),
  },
  {
    path: '/om-oss/forsikring',
    name: 'Insurances',
    component: () => import('@/screens/aboutUs/Insurances.vue'),
  },
  {
    path: '/om-oss/pensjon',
    name: 'Pension',
    component: () => import('@/screens/aboutUs/Pension.vue'),
  },
  {
    path: '/om-oss/sosialt',
    name: 'Social',
    component: () => import('@/screens/aboutUs/Social.vue'),
  },
  {
    path: '/om-oss/personalhandbok',
    name: 'EmployeeHandbook',
    component: () => import('@/screens/aboutUs/EmployeeHandbook.vue'),
  },
  {
    path: '/kontakt',
    name: 'Contact',
    component: () => import('@/screens/contact/Contact.vue'),
  },
  {
    path: '/saker',
    name: 'Stories',
    component: () => import('@/screens/stories/Stories.vue'),
  },
  {
    path: '/saker/:storySlug',
    name: 'Story',
    component: () => import('@/screens/stories/Story.vue'),
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/screens/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
